// extracted by mini-css-extract-plugin
export default {"container":"sideBar_container__xPcBv"};